export default "__VITE_ASSET__a996df47__"